
import { defineComponent, ref, computed, onMounted } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import HoSoQuickDrawer from "@/components/customers/HoSoQuickDrawer.vue";
import FlowNav from "@/components/FlowNav.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"
import Permission from "@/core/config/Permission";
import { titleCaseName } from "@/core/helpers/format";
import { debounce } from "debounce";
import { hideModal } from "@/core/helpers/dom";

interface ICustomer {
  id: string;
  profileCode: string;
  fullName: string;
  index: string;
  idCard: string;
  phase: string;
  adMethod: string;
  score: string;
  priority: string;
  adMajor: string;
  typeAdmission: string;
}
interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}
interface IData {
  phase: string;
  majorId: number;
  priority: string;
  typeAdmission: string;
  method: number;
}
interface IDataAuth {
  dayOfDecision: string;
  code: string;
  dayOfDecision2: string;
  code2: string;

}
export default defineComponent({
  name: "admission-results",
  components: {
    Datatable,
    HoSoQuickDrawer,
    FlowNav,
  },
  data() {
    return {
        loading: true,
    }
  },
  watch: {
    search: debounce(async function (this) {
      this.searchItems()
    }, 300)
  },
  methods: {
    titleCaseName, //expose cho template (import module-scope không tự vào Options API)
    // Click Họ tên -> drawer xem nhanh hồ sơ (theo idAdReg của winner)
    openQuickView(record) {
      const adRegId = record.idAdReg
      if (!adRegId) return
      const d: any = this.$refs.quickDrawer
      d?.open(adRegId)
    },
    modalReexamination() {
      this.kt_modal_re_exam?.click()
      if(this.arrPhaseReAdmission.length!=0) {
        let temp = this.arrPhaseReAdmission[0] as any
        this.formData.phase = temp.id
      }
    },
    modalAdmissionConfirmation() {
      this.kt_modal_click_admission_confirm?.click()
      if(this.arrPhaseReAdmission.length!=0) {
        let temp = this.arrPhaseReAdmission[0] as any
        this.formData.phase = temp.id
      }
    },
    async getData() {
      this.initCustomers = []
      this.tableData = []
      this.arrPhaseReAdmission = []
      await axios.get('/admission/passed/temp?idAdMethod=9')
      .then(( {data} ) => {
        data.items.forEach((item,index) => {
          if(this.arrPhaseReAdmission.findIndex((it:any) => it.id == item.phase) == -1) {
            this.arrPhaseReAdmission.push(this.arrPhase.filter((i:any) =>i.id == item.phase)[0] as never)
          }
          let temp = {
            id: item.id,
            idAdReg: item.idAdReg,
            idStudent: item.idStudent,
            profileCode: item.profileCode,
            fullName: item.fullName,
            index: index+1,
            idCard: item.idCard,
            phase: item.phase,
            adMethod: item.adMethod,
            score: item.averageScore?item.averageScore<13?item.averageScore.toFixed(2):item.averageScore:item.passedUmtCondition,
            priority: 'NV'+item.priority, //gọn: NV1/NV2/NV3
            adMajor: item.adMajor,
            typeAdmission: item.graduationStatus,
            isExtra: item.isExtra,
          }
          this.tableData.push(temp as never)
        })
        this.loading = false
        this.initCustomers.splice(0, this.tableData.length, ...this.tableData);
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    },
  },
  async created() {
    await axios.get('/admission/method')
    .then(( {data} ) => {
      this.arrAdmissionMethod = data
      let temp = {
        id: 0,
        methodNo: 0,
        name: "Tất cả",
        shortname: "Tất cả",
      }
      this.arrAdmissionMethod.unshift(temp as never)
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
   
    await axios.get('/phase')
    .then(( {data} ) => {
      this.arrPhase = data.map(i => {return {name:'Đợt '+i.phaseNo,id:i.phaseNo}})
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
    await axios.get('/phase/item/current')
    .then(( {data} ) => {
      this.formData.phase = data.phaseNo
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
    axios.get('/major')
    .then(( {data} ) => {
      // Trang LIÊN THÔNG: chỉ ngành hệ liên thông (cờ majors.isarticulation, bật ở Cài đặt xét tuyển).
      // Trước đây hardcode mã '7480201' -> ngành LT mới mở (7480201_LT) không lọt vào danh sách.
      data.filter(item => item.isarticulation).forEach(item => {
        let temp = {
          value: item.code,
          name: item.code+'-'+item.name,
          code: item.combination.split(','),
          id: item.id
        }
      this.arrMajors.push(temp as never)
      })
      //console.log('arrMajors',this.arrMajors)
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
    this.getData()
  },
  setup() {
    const arrPhase = ref([] as any)
    const arrPhaseReAdmission = ref([] as any)
    const arrAdmissionMethod = ref([] as any)
    
    const rules = ref({
      code: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      dayOfDecision: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      code2: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      dayOfDecision2: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
    })
    const arrMajors = ref([{
        value: 0,
        name: 'Tất cả',
        code: '0',
        id: 0
    }]) 
    const addExporResultModalRef = ref<null | HTMLElement>(null);
    const kt_modal_reexamination = ref<null | HTMLElement>(null);
    const kt_modal_admission_confirmation = ref<null | HTMLElement>(null);
    const kt_modal_re_exam = ref<null | HTMLElement>(null);
    const kt_modal_click_admission_confirm = ref<null | HTMLElement>(null);
    
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 25,
    });
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
        class: "d-flex",
        method: "checkall",
      },
      //Thứ tự 2026-07: định danh (Mã, Tên, CCCD) -> kết quả (Ngành, NV, ĐTT) -> Đợt -> Loại TT cạnh action
      {
        name: "MÃ HỒ SƠ",
        key: "profileCode",
        sortable: false,
        class: "w-90px text-nowrap",
      },
      {
        name: "HỌ TÊN",
        key: "fullName",
        sortable: true,
        class: "min-w-175px text-nowrap",
      },
      {
        name: "CMND/CCCD",
        key: "idCard",
        sortable: false,
        class: "min-w-100px text-nowrap",
      },
      {
        name: "Ngành",
        key: "adMajor",
        sortable: true,
        class: "min-w-150px",
      },
      {
        name: "NV",
        key: "priority",
        sortable: true,
        class: "text-center text-nowrap",
      },
      {
        name: "ĐTT", // Điểm trúng tuyển
        key: "score",
        sortable: true,
        class: "text-center text-nowrap",
      },
      {
        name: "Đợt",
        key: "phase",
        sortable: false,
        class: "text-center w-50px",
      },
      {
        name: "Loại trúng tuyển",
        key: "typeAdmission",
        sortable: true,
      },
      // Bỏ cột Phương thức: trang này chỉ chứa hồ sơ LIÊN THÔNG (PT9) — cột luôn 1 giá trị
    ]);
    const arrTag =  {
      "not_graduated": {
        label:"Có điều kiện",
        state: "warning",
      },
      "graduated": {
        label:"Chính thức",
        state: "success",
      },
      "temp_graduated": {
        label:"Chính thức",
        state: "success",
      },
    }
    const formData =  ref<IData>({
        phase: '1',
        majorId: 0,
        priority: '0',
        typeAdmission: '0',
        method: 0,
    });
    const formDataAuth =  ref<IDataAuth>({
        code: '',
        dayOfDecision: '',
        code2: '',
        dayOfDecision2: '',
    });
    const tableData = ref<Array<ICustomer>>([]);
    const initCustomers = ref<Array<ICustomer>>([]);
    // Checkbox chọn hồ sơ: xác nhận trúng tuyển / xét tuyển lại theo LỰA CHỌN (không chọn = cả đợt như cũ)
    const checkedCustomers = ref<any[]>([]);
    const checkDefault = ref(false);
    const checkAll = (value: boolean) => {
      checkDefault.value = value;
      checkedCustomers.value = [];
      if (!value) return;
      document.querySelectorAll('.form-auto-check').forEach((e: any) => {
        checkedCustomers.value.push(e.value);
      });
    };
    // Đếm theo nhóm (hiển thị trong modal Xác nhận trúng tuyển)
    // Đếm theo nhóm PHẢI khớp tập hồ sơ submitFormDataconfirm sẽ áp: thuộc ĐỢT đang chọn + nếu tick thì chỉ hồ sơ tick.
    // Trước đây đếm cả tableData -> chọn 1 mà modal khoe 3+1 (đánh lừa) + hiện cả 2 mục QĐ bắt buộc.
    const confirmTargetRows = computed(() => {
      let rows = (tableData.value as any[]).filter(i => i.phase == formData.value.phase)
      if (checkedCustomers.value.length) {
        rows = rows.filter(i => checkedCustomers.value.includes(i.id))
      }
      return rows
    });
    const statOfficial = computed(() => confirmTargetRows.value.filter(i => i.typeAdmission == 'graduated' || i.typeAdmission == 'temp_graduated').length);
    const statConditional = computed(() => confirmTargetRows.value.filter(i => i.typeAdmission == 'not_graduated').length);
    onMounted(async () => {
        
       //getData()
      //initCustomers.value.splice(0, tableData.value.length, ...tableData.value);
      //console.log(tableData.value)
    });
    const search = ref<string>("");
    const searchItems = () => {
      
      tableData.value.splice(0, tableData.value.length, ...initCustomers.value);
      if (search.value !== "") {
        let results: Array<ICustomer> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }
    };

    const searchingFunc = (obj, value): boolean => {
      obj = JSON.parse(JSON.stringify(obj))
      for (let key in obj) {
        if (obj[key] && (typeof obj[key] === "string")) {
          if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
            return true;
          }
        }
      }
      return false;
    };
    function popupLoading() {
       Swal.fire({
        html:"<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    }
    const formRef = ref<null | HTMLFormElement>(null);
    const formDataReExam = ref<null | HTMLFormElement>(null);
    const formDataconfirm = ref<null | HTMLFormElement>(null);
    const submit = () => {
      if (!formRef.value) {
        return;
      }
      formRef.value.validate(async (valid) => {
        if (valid) {
          popupLoading()
          let data = {
              "phase": formData.value.phase != '0'?formData.value.phase:undefined,
              "majorId": formData.value.majorId != 0?formData.value.majorId:undefined,
              "priority": formData.value.priority != '0'?+formData.value.priority:undefined,
              "graduationStatus": formData.value.typeAdmission != '0'?formData.value.typeAdmission == 'graduated'?['graduated','temp_graduated']:formData.value.typeAdmission:undefined,
          }
            await axios.post('/admission/export/excel/passedappraisal', data,{ responseType: 'blob' })
            .then(({data}) => {
              const url = URL.createObjectURL(new Blob([data], {
                  type: 'application/vnd.ms-excel'
              }))
              const link = document.createElement('a')
              link.href = url
              // Tên file kèm ngày xuất (DD-MM-YYYY) để phân biệt các lần xuất
              const _d = new Date()
              const _dateStr = `${String(_d.getDate()).padStart(2, '0')}-${String(_d.getMonth() + 1).padStart(2, '0')}-${_d.getFullYear()}`
              link.setAttribute('download', `danh-sach-trung-tuyen-lien-thong_${_dateStr}.xlsx`)
              document.body.appendChild(link)
              link.click()
              Swal.close()
              hideModal(addExporResultModalRef.value);
            }).catch(err=> {
              console.log('err',err)
            })
        } else {
          return false;
        }
      });
    };
    const submitReExamination = () => {
      if (!formDataReExam.value) {
        return;
      }
      formDataReExam.value.validate(async (valid) => {
        if (valid) {
          popupLoading()
          let data = {
              "phase": formData.value.phase != '0'?+formData.value.phase:undefined,
              // Trang này CHỈ chứa hồ sơ liên thông -> khóa cứng PT9 (trước đây chọn "Tất cả"
              // sẽ reset nhầm kết quả của MỌI phương thức trong đợt)
              "idAdMethod": 9,
              // Có tick chọn -> chỉ xét tuyển lại các hồ sơ đã chọn (BE lọc thêm theo ids)
              "ids": checkedCustomers.value.length ? checkedCustomers.value : undefined,
          }
            await axios.post('/admission/passed/reset', data)
            .then(({data}) => {
              Swal.fire({
                text: "Kết quả xét tuyển sinh đã được hủy thành công",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                location.reload()
                Swal.close()
              });
              hideModal(kt_modal_reexamination.value);
            }).catch(err=> {
              console.log('err',err)
            })
        } else {
          return false;
        }
      });
    };
    const submitFormDataconfirm = () => {
      if (!formDataconfirm.value) {
        return;
      }
      formDataconfirm.value.validate(async (valid) => {
        // Có tick chọn -> chỉ xác nhận các hồ sơ ĐÃ CHỌN thuộc đợt; không chọn -> cả đợt (hành vi cũ)
        let ids = tableData.value.filter((item: any) => item.phase == formData.value.phase)
        if (checkedCustomers.value.length) {
          ids = ids.filter((item: any) => checkedCustomers.value.includes(item.id))
        }
        if (ids.length === 0) {
          Swal.fire({ text: 'Không có hồ sơ nào (trong số đã chọn) thuộc đợt này.', icon: 'warning', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
        if (valid) {
          Swal.fire({
          html: `Bạn có muốn xác nhận đợt ${formData.value.phase} với <span class="text-danger fs-3">${ids.length}</span> hồ sơ không?`,
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Trở lại",
          customClass: {
            confirmButton: "btn btn-primary order-2",
            cancelButton: "btn btn-light order-1",
          },
        }).then(async (result) => {
          if(result.isConfirmed) {
            popupLoading()
            let arrGraduated = ids.filter(item =>item.typeAdmission == 'graduated' || item.typeAdmission == 'temp_graduated')
            let arrNot_graduated = ids.filter(item =>item.typeAdmission == 'not_graduated')
            let graduation = undefined as any
            let not_graduated = undefined as any
            if(arrGraduated.length!=0) {
              graduation = {
                "decisionCode": formDataAuth.value.code,
                "ids": arrGraduated.map(i => {return i.id}),
                "decisionDate": formDataAuth.value.dayOfDecision,
              }
            }
            if(arrNot_graduated.length!=0) {
              not_graduated = {
                "decisionCode": formDataAuth.value.code2,
                "ids": arrNot_graduated.map(i => {return i.id}),
                "decisionDate": formDataAuth.value.dayOfDecision2,
              }
            }
          let data = {
              "phase": formData.value.phase,
              "graduation": graduation,
              "notGraduation": not_graduated,
          }
            await axios.post('/admission/passed/confirm', data)
            .then(({data}) => {
              Swal.fire({
                text: `Đã xác nhận ${ids.length} hồ sơ thành công!`,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                location.reload()
                Swal.close()
              });
              hideModal(kt_modal_admission_confirmation.value);
            }).catch(err=> {
              Swal.fire({
                text: "Có lỗi xảy ra trong quá trình xử lý!",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                Swal.close()
              });
              console.log('err',err)
            })
          }
          Swal.close()
        });
          
        } else {
          return false;
        }
      });
    };
    
    return {
      tableData,
      initCustomers,
      tableHeader,
      search,
      searchItems,
      pagination,
      Permission,
      arrTag,
      addExporResultModalRef,
      formData,
      formDataReExam,
      arrMajors,
      arrPhase,
      formRef,
      submit,
      arrAdmissionMethod,
      submitReExamination,
      kt_modal_reexamination,
      submitFormDataconfirm,
      kt_modal_admission_confirmation,
      formDataconfirm,
      formDataAuth,
      rules,
      arrPhaseReAdmission,
      kt_modal_re_exam,
      kt_modal_click_admission_confirm,
      checkedCustomers,
      checkDefault,
      checkAll,
      statOfficial,
      statConditional,
    };
  },
});
